import axiosInstance from "./axiosInstance";
import ProductChangeResponse from "../types/ProductChangeResponse";
import {getParams} from "./util";
import {ProductChangeFromOtherFilterType, ProductChangeToOtherFilterType} from "../components/PrescriptionView/types"
import ProductChangeFromOtherDTO from "../types/ProductChangeFromOtherDTO";
import ProductChangeToOtherDTO from "../types/ProductChangeToOther";

export const fetchProductChangesFromOther = async (params: any) => {
    const queryParams = getParams(params);
    const url = `/prescriptions/product-change/from-other${queryParams}`;
    return axiosInstance.get<ProductChangeResponse<ProductChangeFromOtherDTO>>(url)
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))
}

export const fetchProductChangesToOther = async (params: any) => {
    const queryParams = getParams(params);
    const url = `/prescriptions/product-change/to-other${queryParams}`;
    return axiosInstance.get<ProductChangeResponse<ProductChangeToOtherDTO>>(url)
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))
}

export const fetchProductChangesFromOtherFilters = async () =>
    axiosInstance.get<ProductChangeFromOtherFilterType>("/prescriptions/product-change/from-other/filters")
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))

export const fetchProductChangesToOtherFilters = async () =>
    axiosInstance.get<ProductChangeToOtherFilterType>("/prescriptions/product-change/to-other/filters")
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))



export const fetchProductChangeFromOtherByPrescriptionId = async (prescriptionId: any) => {
    return axiosInstance.get<ProductChangeFromOtherDTO>(`/prescriptions/${prescriptionId}/product-change/from-other`)
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))
}

export const fetchProductChangeToOtherByPrescriptionId = async (prescriptionId: any) => {
    return axiosInstance.get<ProductChangeToOtherDTO>(`/prescriptions/${prescriptionId}/product-change/to-other`)
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))
}

export const downloadProductChangesFromOtherExcel = async (params: any): Promise<any | void> => {
    const queryParams = getParams(params);
    return axiosInstance.get<any>(`/prescriptions/product-change/from-other/excel${queryParams}`, {
        responseType: 'blob',
    })
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const downloadProductChangesToOtherExcel = async (params: any): Promise<any | void> => {
    const queryParams = getParams(params);
    return axiosInstance.get<any>(`/prescriptions/product-change/to-other/excel${queryParams}`, {
        responseType: 'blob',
    })
        .then(response => response.data)
        .catch(error => error.response.data)
}